import SectionExploreSolutions, {
  SectionExploreSolutionsTemplate as SectionExploreSolutionsTemplateComponent,
} from "./SectionExploreSolutions";
export default SectionExploreSolutions;
export const SectionExploreSolutionsTemplate =
  SectionExploreSolutionsTemplateComponent;
